var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1 bg-white",
          attrs: {
            color: "white",
            "text-color": "primary",
            "underline-color": "primary",
            align: "justify"
          },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "live_classes",
              label: _vm.$t(_vm.title_presential),
              icon: "fas fa-chalkboard-teacher"
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            {
              staticClass: "q-px-md q-pb-xl q-mt-md",
              attrs: { name: "live_classes" }
            },
            [
              _vm.finished_loading
                ? _c("div", { staticClass: "row gutter-sm" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [_c("filter-live-classes")],
                      1
                    ),
                    _c("div", { staticClass: "col-xs-12 col-sm-9" }, [
                      _vm.banners.length > 0
                        ? _c(
                            "div",
                            { staticClass: "col-12 desktop-only" },
                            [
                              _c(
                                "q-carousel",
                                {
                                  staticClass: "text-white",
                                  attrs: {
                                    height: "200px",
                                    infinite: "",
                                    autoplay: ""
                                  }
                                },
                                _vm._l(_vm.banners, function(banner, index) {
                                  return _c("q-carousel-slide", {
                                    key: index,
                                    attrs: { "img-src": banner.image_desktop }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.banners.length > 0 && _vm.showBanner
                        ? _c(
                            "div",
                            { staticClass: "col-12 mobile-only" },
                            [
                              _c(
                                "q-carousel",
                                {
                                  staticClass: "text-white",
                                  attrs: {
                                    height: _vm.getHeight + "px",
                                    infinite: "",
                                    autoplay: ""
                                  }
                                },
                                _vm._l(_vm.banners, function(banner, index) {
                                  return _c("q-carousel-slide", {
                                    key: index,
                                    attrs: { "img-src": banner.image_mobile }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "row gutter-md q-mt-xs" },
                        [
                          _vm._l(_vm.filteredLiveClasses, function(
                            live_class,
                            index
                          ) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "col-xs-12 col-sm-12"
                              },
                              [
                                _vm.$q.platform.is.desktop
                                  ? _c("card-desktop", {
                                      key: live_class.id,
                                      attrs: { live_class: live_class },
                                      on: {
                                        subscribe_live_class: function($event) {
                                          return _vm.subscribeLiveClass(
                                            live_class
                                          )
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                _vm.$q.platform.is.mobile
                                  ? _c("card-mobile", {
                                      key: live_class.id,
                                      attrs: { live_class: live_class },
                                      on: {
                                        subscribe_live_class: function($event) {
                                          return _vm.subscribeLiveClass(
                                            live_class
                                          )
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          _vm.filteredLiveClasses.length == 0
                            ? _c(
                                "div",
                                { staticClass: "col-xs-12 col-sm-12" },
                                [
                                  _c(
                                    "q-card",
                                    [
                                      _c("q-card-title", [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.$t("no_live_class_found")
                                            ) +
                                            "\n                                "
                                        )
                                      ]),
                                      _c("q-card-separator"),
                                      this.search ||
                                      this.selected_areas.length > 0
                                        ? _c("q-card-main", [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "searched_term_returned_no_results"
                                                  )
                                                ) +
                                                "\n                                "
                                            )
                                          ])
                                        : _c("q-card-main", [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "there_are_no_live_classes_avaliable_at_the_moment"
                                                  )
                                                ) +
                                                "\n                                "
                                            )
                                          ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ])
                  ])
                : _vm._e(),
              _c(
                "q-inner-loading",
                { attrs: { visible: !_vm.finished_loading } },
                [
                  _c("q-spinner-dots", {
                    attrs: { size: 60, color: "secondary" }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          staticClass: "dialog-webcast",
          attrs: { "prevent-close": "" },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "tertiary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        return _vm.cancelSubscribeLiveClass()
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: {
                      color: _vm.getLiveClassSubscribeButtonColor(),
                      label: _vm.$t(_vm.getLiveClassSubscribeButton())
                    },
                    on: {
                      click: function($event) {
                        return _vm.saveSubscribeLiveClass()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_subscribe_live_class,
            callback: function($$v) {
              _vm.confirm_subscribe_live_class = $$v
            },
            expression: "confirm_subscribe_live_class"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t(_vm.getLiveClassSubscribeTitle())))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$t(_vm.getLiveClassSubscribeText()) +
                    " " +
                    _vm.live_class.title
                ) +
                "\n        "
            )
          ]),
          !_vm.live_class.live_class_user_subscribed
            ? _c(
                "span",
                { attrs: { slot: "body" }, slot: "body" },
                [
                  _c(
                    "q-field",
                    [
                      _c("q-checkbox", {
                        attrs: {
                          label: _vm.$t("receive_emails_about_this_live_class")
                        },
                        model: {
                          value: _vm.check_emails_live_class,
                          callback: function($$v) {
                            _vm.check_emails_live_class = $$v
                          },
                          expression: "check_emails_live_class"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }